import React, { Component } from 'react';
import { Formik, Field, ErrorMessage, FieldProps } from 'formik';
import * as Yup from 'yup';
import { Button, Form, Grid, Header, Message } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { EUserGroup } from '@relab/alstom-ptw-shared';

import { ActionType, RootState, ServerRequestStatus } from '../../redux/types';
import { UserSelectComponent } from '../UserSelectComponent';
import { ProjectCreateValues } from '../../interfaces';
import { appStateServerRequests } from '../../redux/selectors';
import { projectCreateAction } from '../../redux/actions';
import { TranslationComponent } from '../TranslationComponent';
import i18n from 'i18next';
import { withTranslation } from 'react-i18next';

const CreateProjectSchema = (t: typeof i18n.t) =>
  Yup.object().shape({
    name: Yup.string().min(2, t('Too Short!')).max(50, t('Too Long!')).required(t('Name is required')),
    prtcm: Yup.string().required(t('PRTCM is required')),
  });

interface ProjectCreateComponentProps {
  i18n: typeof i18n;
  t: typeof i18n.t;
  projectCreateAction: any;
  createProjectServerRequest?: ServerRequestStatus;
}

class PProjectCreateComponent extends Component<ProjectCreateComponentProps> {
  handleSubmit = (values: ProjectCreateValues) => {
    this.props.projectCreateAction({
      ...values,
      assignees: [
        {
          user: values.prtcm,
          group: EUserGroup.PRTCM,
        },
      ],
    });
  };

  render() {
    const { createProjectServerRequest, t } = this.props;

    const initialValues = {
      name: '',
      prtcm: '',
    };

    return (
      <Formik initialValues={initialValues} validationSchema={CreateProjectSchema(t)} onSubmit={this.handleSubmit}>
        {({ handleSubmit, isSubmitting }) => (
          <Form
            error
            loading={isSubmitting && createProjectServerRequest && createProjectServerRequest.pending}
            onSubmit={handleSubmit}
          >
            <Grid>
              <Grid.Row>
                <Grid.Column floated="left" width={2}>
                  <Header>
                    <TranslationComponent stringKey={'New Project'} />
                  </Header>
                </Grid.Column>
                <Grid.Column floated="right" width={2}>
                  <Button primary fluid type="submit">
                    <TranslationComponent stringKey={'Create project'} />
                  </Button>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={2}>
                <Grid.Column>
                  <Field name="name">
                    {({ field }: FieldProps) => (
                      <Form.Field>
                        <label>
                          <TranslationComponent stringKey={'Project name'} />
                        </label>
                        <input {...field} />
                      </Form.Field>
                    )}
                  </Field>
                  <ErrorMessage name="name">{(msg) => <Message error content={msg} />}</ErrorMessage>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={2}>
                <Grid.Column>
                  <Field name="prtcm">
                    {({ field }: FieldProps) => (
                      <Form.Field>
                        <label>
                          <TranslationComponent stringKey={'PRTCM'} />
                        </label>
                        <UserSelectComponent name={field.name} />
                      </Form.Field>
                    )}
                  </Field>
                  <ErrorMessage name="prtcm">{(msg) => <Message error content={msg} />}</ErrorMessage>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  {createProjectServerRequest && createProjectServerRequest.success && (
                    <Message content={t('Project created')} />
                  )}
                  {createProjectServerRequest && createProjectServerRequest.error && (
                    <Message error content={createProjectServerRequest.error} />
                  )}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Form>
        )}
      </Formik>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  createProjectServerRequest: appStateServerRequests(state, ActionType.PROJECT_CREATE),
});

export const ProjectCreateComponent = connect(mapStateToProps, {
  projectCreateAction,
})(withTranslation()(PProjectCreateComponent));
